import { gql } from "@apollo/client";

export const ACKNOWLEDGE_TRIP_CHANGES_NOTIFICATION_MUTATION = gql`
  mutation AcknowledgeTripChange($input: AcknowledgeTripChangeInput!) {
    acknowledgeTripChange(input: $input) {
      success
    }
  }
`;
